import { GearboxData } from '../../../models';
import { useAppDispatch, useAppSelector } from '../../common';
import { hasNullOrUndefined } from '../../../services';
import { setGearboxInertiaDialog, setGearboxInputData, setLoadInertiaLowDialog, setMesRequest, toggleLoading } from '../../../store';
import { MotorDriveConnection } from '../../../enums';
import { useHook } from '../../Hooks';
import { useEffect } from 'react';

export const useGearboxData = () => {
    const dispatch = useAppDispatch();
    const mesRequest = useAppSelector(state => state.motor.mesRequest);
    const updateFilters = useAppSelector(state => state.motor.updateFilters);
    const { getCalculationData } = useHook(x => x.filter)();

    useEffect(() => {
        const { n2, gearboxInertia, loadInertia } = mesRequest.gearboxData;

        gearboxInertia && gearboxInertia < 0 && dispatch(setGearboxInertiaDialog(true));
        loadInertia && loadInertia < 0 && dispatch(setLoadInertiaLowDialog(true));

        dispatch(setGearboxInputData({
            n2: n2?.toString(),
            gearboxInertia: gearboxInertia?.toString(),
            loadInertia: loadInertia?.toString()
        }));
    }, [updateFilters]);

    const handleGearboxChange = async (subset: Partial<GearboxData>) => {
        dispatch(toggleLoading());

        const { gearboxData } = mesRequest;
        const { motorDriveConnection } = mesRequest.gearboxData;
        const newMesRequest = { ...mesRequest, gearboxData: { ...mesRequest.gearboxData, ...subset } };

        dispatch(setMesRequest(newMesRequest));

        if (motorDriveConnection === MotorDriveConnection.WithGearbox
            ? !hasNullOrUndefined(gearboxData)
            : !hasNullOrUndefined(gearboxData, 'motorInertia', 'loadInertia')) {
            await getCalculationData(newMesRequest);
        }

        dispatch(toggleLoading());
    };

    return {
        onGearboxChange: handleGearboxChange
    };
};
